import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Link } from 'wouter';

import MagazineIcon from '../icons/Magazine';

import styles from '../../../styles/buttons/more.module.css';

interface MoreButtonProps {
    href?: string | null;
    action?: 'read' | 'view';
    purple?: boolean;
    className?: string | null;
}

function MoreButton({
    href = null,
    action = 'read',
    purple = false,
    className = null,
}: MoreButtonProps) {
    return (
        <Link
            href={href || '#'}
            className={classNames([
                purple ? 'more-gradient-purple' : 'more-gradient',
                styles.container,
                {
                    [styles.purple]: purple,
                    [className]: className !== null,
                },
            ])}
        >
            <MagazineIcon eyeColor="#fff" className={styles.icon} />
            <span className={styles.label}>
                {action === 'read' ? (
                    <FormattedMessage
                        defaultMessage="Lire la suite +"
                        description="Read more button label"
                    />
                ) : (
                    <FormattedMessage
                        defaultMessage="Voir la suite +"
                        description="View more button label"
                    />
                )}
            </span>
        </Link>
    );
}

export default MoreButton;
